import gql from 'graphql-tag';

import { CountryFragments } from './CountryType';
import { RegionFragments } from './RegionType';

export const PlaceFragments = {
  id: gql`
    fragment PlaceId on Place {
      _id: externalId
    }
  `,
  carouselItem: gql`
    fragment PlaceCarouselItem on Place {
      _id: externalId
      name
      slug
      latitude
      longitude
      country {
        ...CountryId
        countryName
      }
      region {
        ...RegionId
        name
        regionCode
      }
      unsplashImage {
        id
        imageUrl
      }
    }
    ${CountryFragments.id}
    ${RegionFragments.id}
  `,
};
